/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { eventTrackerSendEvent } from '../fn/event-tracker/event-tracker-send-event';
import { EventTrackerSendEvent$Params } from '../fn/event-tracker/event-tracker-send-event';

@Injectable({ providedIn: 'root' })
export class EventTrackerApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `eventTrackerSendEvent()` */
  static readonly EventTrackerSendEventPath = '/api/event-tracker/events';

  /**
   * Send event to the event tracker.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventTrackerSendEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventTrackerSendEvent$Response(params: EventTrackerSendEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = eventTrackerSendEvent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Send event to the event tracker.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventTrackerSendEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventTrackerSendEvent(params: EventTrackerSendEvent$Params, context?: HttpContext): Observable<void> {
    const resp = this.eventTrackerSendEvent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
